export default "__VITE_ASSET__DDSuaWHE__"